import { createContext as t, useContext as o } from "react";
const e = {
  scrollBack: () => {
  },
  scrollForward: () => {
  },
  setListRef: () => {
  },
  updateNavigators: () => {
  },
  showNextButton: !1,
  showPrevButton: !1
}, s = t(e), a = () => o(s);
export {
  s as CarouselContext,
  a as useCarouselContext
};
